"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _zod = require("zod");

var _SortingDropdown = _interopRequireDefault(require("@insided/destination/uikit/SortingDropdown"));

var sortOptionSchema = _zod.z.object({
  sortType: _zod.z.string(),
  sortDirection: _zod.z.enum(['asc', 'desc']),
  sortLabel: _zod.z.string()
});

var sortingDropdownPropsSchema = _zod.z.object({
  sortOptions: _zod.z.array(sortOptionSchema).min(1)
});

/**
 * Module wrapper for SortingDropdown UI component.
 * Validates props from Twig in development mode.
 * Note: onSortChange cannot be passed from Twig (not serializable).
 */
var SortingDropdownModule = function SortingDropdownModule(props) {
  if (process.env.NODE_ENV !== 'production') {
    var result = sortingDropdownPropsSchema.safeParse(props);

    if (!result.success) {
      console.error('[SortingDropdown] Invalid props from Twig:', result.error.errors);
    }
  }

  var sortOptions = props.sortOptions;
  return (0, _preact.h)(_SortingDropdown.default, {
    sortOptions: sortOptions
  });
};

var _default = SortingDropdownModule;
exports.default = _default;
var cssAnchorName = 'sorting-dropdown-component';
exports.cssAnchorName = cssAnchorName;